import * as yup from 'yup'

export const supportModalSchema = yup.object({
  name: yup.string().required("Поле не може бути порожнім"),
  contact: yup.string().required("Поле не може бути порожнім"),
  message: yup.string().required("Поле не може бути порожнім"),
})